"use client"
import ImageWrapper from "@/components/ImageWrapper";
import { Box } from "@dxp-feed/ui/Box";
import { ResponsiveImage } from "@/components/Common/ResponsiveImage";
import Link from "next/link";
const Image = ({ props }: any) => {
  const currentImage = ResponsiveImage({
    mobileImage: props?.mobileImage,
    tabletImage: props?.tabletImage,
    src: props?.src,
    imagePath: props?.componentData?.image?.["repo:path"],
  });

const isValidLink = !!props?.link && props.link !== '#';
  return (
    <Box as="div" className="mx-auto max-w-[1920px]  pb-3 lg:pb-6">
   <Link href={props?.link || '#'} className={isValidLink ? 'cursor-pointer' : 'cursor-auto'}>
      <ImageWrapper
        src={currentImage}
        height={350}
        width={1950}
        className="m-auto"
        alt={props?.alt ?? "Banner"}

      />
      </Link>
    </Box>
  );
};

export default Image;
